import xhr from './../xhr/'
import xhrGet from './../xhr'
import { rootPath } from './../xhr/config'
/**
 * 对应后端的 /msg/* 所有 API
 */
class DvcTypeService {
  /**
   * 取 msg（命名为 fetch 而非 get 主要是因为是远程操作）
   * @param  {String} options.author   作者名
   * @param  {Number} options.pageIdx  目标页码（默认是第 1 页）
   * @param  {Number} options.quantity 单页请求 msg 的数量（默认每页显示 10 条）
   * @param  {Number} options.msgId
   * @return {Promise}
   */
  fetch ({msgBody} = {}) {
     return xhr({
          method: 'post',
          url: rootPath+'/dvcType/list',
          body: msgBody
      })
  }

   /**
      * 进入msg编辑页面
      * @param  {Object} msgBody { title:{String}, content:{String} }
      * @return {Promise}
      */
     toMod (dvcTypeId) {
       return xhrGet({
         method: 'get',
         url: rootPath+'/dvcType/get/'+dvcTypeId
       })
     }

  /**
   * 新增 msg
   * @param  {Object} dvcTypeBody { name:{String}, codePro:{String} }
   * @return {Promise}
   */
  insertOrUpdate ({dvcTypeBody} = {}) {
    return xhr({
      method: 'post',
      url: rootPath+'/dvcType/insertOrUpdate',
      body: dvcTypeBody
    })
  }

  /**
   * 修改 msg
   * @param  {Object} msgBody { title:{String}, content:{String} }
   * @return {Promise}
   */
  mod (msgBody) {
    let msgId = msgBody.id
    delete msgBody.msgId

    return xhr({
      method: 'put',
      url: rootPath+`/msg/${msgId}`,
      body: msgBody
    })
  }

  /**
   * 删除 msg
   * @param  {Number} msgId
   * @return {Promise}
   */
  del (id) {
    return xhr({
      method: 'delete',
      url: rootPath+`/dvcType/delete/${id}`
    })
  }

}

// 实例化后再导出
export default new DvcTypeService()



// WEBPACK FOOTER //
// ./modules/services/bump/dvcTypeService.js